// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-09923657]{background-color:transparent;height:80px;width:100%}.footer .page_center[data-v-09923657]{display:flex;flex-direction:column;justify-content:center;align-items:center}.footer .page_center .com_box[data-v-09923657]{padding:10px}.footer .page_center .com_box span[data-v-09923657]{margin:0 10px;font-size:12px;color:#333}.footer .page_center .info[data-v-09923657]{font-size:12px;color:rgba(51,51,51,.5)}", ""]);
// Exports
module.exports = exports;
